import { Box, Button, Grid2, Typography } from "@mui/material"
import { useAdminMemoryByApart, useCourseApartmentDetail } from "../../assets/api/useAdminApi"
import { NormalContainerWithHeader } from "../../shared/components/student/NormalComponent";
import { IdAutoCompleteField } from "../../shared/components/formfields/IdAutoCompleteField";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import CustomDivider from "../../shared/utils/CustomDivider";
import { Grid_Gap } from "../../shared/constants";
import { SkeletonCom } from "../../shared/utils/SkeletonCom";
import useAuthStore from "../../store/useAuthStore";
import { ImageCard } from "../student/Memories";
import { useApartmentOptions } from "../admin/option/ApartmentOption";

const CommonSeeMemory = () => {
    const { courseApartmentOption } = useApartmentOptions()
    const { user } = useAuthStore()
    const [selectedApartment, setSelectedApartment] = useState({})
    const [selectedCourse, setSelectedCourse] = useState({})
    const { data: courselist, isLoading } = useCourseApartmentDetail({ apartments_id: selectedApartment?.id })
    const {
        data,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        isLoading: isMomentLoading
    } = useAdminMemoryByApart({ course_id: selectedCourse?.id, apartment_id: selectedApartment?.id });

    const momentlist = data?.pages.flatMap((page) => page.data) || [];

    const CourseOptions = courselist?.map((item) => ({
        id: item?.course_id,
        label: item?.course_name,
        value: item?.course_name,
    })) || [];
    const validationSchema = Yup.object().shape({});
    const initialValues = {
        apartment_name: user.role === "organizer" ? user?.apartment_id : "",
    };
    const handleSubmit = () => { }

    useEffect(() => {
        if (user.role === "organizer") {
            setSelectedApartment({ id: user?.apartment_id })
        }
    }, [user?.role, user?.apartment_id , user])



    return (
        <NormalContainerWithHeader headerText={"Check Moments"}>
            <Formik initialValues={initialValues} enableReinitialize validationSchema={validationSchema} onSubmit={handleSubmit}>
                {() => (
                    <Form>
                        <Grid2 container spacing={Grid_Gap}>
                            <Grid2 size={{ xs: 12, sm: 4 }}>
                                <Field
                                    name="apartment_name"
                                    component={IdAutoCompleteField}
                                    options={courseApartmentOption.options}
                                    label="Select Apartment"
                                    isLoading={courseApartmentOption.isLoading}
                                    onValueChange={(val) => {
                                        setSelectedApartment(val)
                                    }}
                                    disabled={user.role === "organizer"}

                                />
                            </Grid2>
                            <Grid2 size={{ xs: 12, sm: 4 }}>
                                <Field
                                    name="course_id"
                                    component={IdAutoCompleteField}
                                    options={CourseOptions}
                                    label="Select Course"
                                    isLoading={isLoading}
                                    onValueChange={(val) => {
                                        setSelectedCourse(val)
                                    }}
                                />
                            </Grid2>

                        </Grid2>
                    </Form>)}
            </Formik>
            {/* <CustomDivider /> */}


            {
                hasNextPage && (<Box sx={{ display: "flex", justifyContent: "end" }}>

                    <Button
                        variant="outlined"
                        onClick={() => fetchNextPage()}
                        disabled={isFetchingNextPage}
                    >
                        {isFetchingNextPage ? 'Loading...' : 'View More'}
                    </Button>


                </Box>)
            }
            <CustomDivider />


            <Grid2 container spacing={Grid_Gap}>
                {!isMomentLoading && (

                    <>
                        {momentlist.length === 0 ? (
                            <Typography variant="body2" mt={"1rem"} textAlign={"center"}>No Moments</Typography>
                        ) : (
                            momentlist
                                .reduce((acc, _, index) => {
                                    if (index % 4 === 0) acc.push(momentlist.slice(index, index + 4));
                                    return acc;
                                }, [])
                                .map((chunk, groupIndex) => (
                                    <React.Fragment key={groupIndex}>

                                        {chunk[0] && (
                                            <ImageCard src={chunk[0]} height={400} />
                                        )}

                                        <Grid2
                                            container
                                            size={{ lg: 4, xs: 12 }}
                                            direction="column"
                                            spacing={1}
                                            justifyContent="space-between"
                                        >
                                            {chunk[1] && (
                                                <ImageCard src={chunk[1]} height={195} isNested={true} />
                                            )}
                                            {chunk[2] && (
                                                <ImageCard src={chunk[2]} height={195} isNested={true} />
                                            )}
                                        </Grid2>
                                        {chunk[3] && (
                                            <ImageCard src={chunk[3]} height={400} />
                                        )}
                                    </React.Fragment>
                                ))
                        )}
                    </>
                )}


                {isMomentLoading && (
                    <>
                        <Grid2 size={{ lg: 4, xs: 12 }}>
                            <SkeletonCom height={400} />
                        </Grid2>
                        <Grid2
                            container
                            size={{ lg: 4, xs: 12 }}
                            direction="column"
                            spacing={1}
                            justifyContent="space-between"
                        >
                            <Grid2 size={{ lg: 12, xs: 12 }}>
                                <SkeletonCom height={195} />
                            </Grid2>
                            <Grid2 size={{ lg: 12, xs: 12 }}>
                                <SkeletonCom height={195} />
                            </Grid2>
                        </Grid2>
                        <Grid2 size={{ lg: 4, xs: 12 }}>
                            <SkeletonCom height={400} />
                        </Grid2>
                    </>
                )}

            </Grid2>
        </NormalContainerWithHeader>
    )
}

export default CommonSeeMemory